import {useState} from "react";
import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";
import {profile_url} from "../constant";

const CustomUserProfile = ({user, sx, code = false, width = 40}) => {
	const [imgError, setImgError] = useState(false);
	const [loaded, setLoaded] = useState(false);

	const profile = user?.profile_image && !imgError ? profile_url + user.profile_image : null;

	const fullName = `${user?.first_name || ""} ${user?.last_name || ""}`.trim();
	const user_code = user?.user_code;

	const initials = (user?.first_name?.charAt(0) || "") + (user?.last_name?.charAt(0) || "");

	const shortName = initials.toUpperCase();
	const showInitialsOnly = code === true;

	return (
		<Tooltip title={showInitialsOnly ? user_code : fullName}>
			<Avatar
				src={showInitialsOnly ? null : profile}
				onError={() => setImgError(true)}
				imgProps={{
					onLoad: () => setLoaded(true),
				}}
				sx={{
					width,
					height: width,
					bgcolor: showInitialsOnly || !profile ? "primary.main" : undefined,
					fontWeight: 800,
					fontSize: 14,

					/* Perfect 1:1 avatar fix + animation */
					"& img": {
						width: "100%",
						height: "100%",
						objectFit: "cover", // always fill square
						objectPosition: "center", // keep face in center
						borderRadius: "50%",
						opacity: loaded ? 1 : 0,
						transform: loaded ? "scale(1)" : "scale(1.12)",
						transition: "all 0.4s ease",
					},

					...sx,
				}}>
				{(!showInitialsOnly && !profile) && shortName}
			</Avatar>
		</Tooltip>
	);
};

export default CustomUserProfile;
